import JsBarcode from "jsbarcode";
import { Image } from "@react-pdf/renderer";

interface BarcodePdfProps {
  value: string;
}

const generateBarcode = (value: string) => {
  const canvas = document.createElement("canvas");
  JsBarcode(canvas, value, {
    format: "CODE128",
    displayValue: false,
    width: 2,
    fontSize: 20,
    height: 21,
    // Default margin is 10px — adds large empty band above bars in the PNG
    margin: 2,
  });
  return canvas.toDataURL("image/png");
};

/**
 * Renders a barcode image for use in PDF documents.
 * @param {BarcodePdfProps} props - The props for the component.
 * @param {string} props.value - The value to encode in the barcode.
 */
function BarcodePdf({ value }: BarcodePdfProps) {
  return <Image src={generateBarcode(value)} style={{ width: 100, height: 21 }} />
}

export default BarcodePdf;
